type PropTypes = {
  className?: string
}

const DesignIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      className={className}
    >
      <path fill="currentColor" d="M4.75.25H1.375A1.125 1.125 0 0 0 .25 1.375V4.75a1.125 1.125 0 0 0 1.125 1.125H4.75A1.125 1.125 0 0 0 5.875 4.75V1.375A1.125 1.125 0 0 0 4.75.25Zm0 4.5H1.375V1.375H4.75V4.75ZM12.625.25H9.25a1.125 1.125 0 0 0-1.125 1.125V4.75A1.125 1.125 0 0 0 9.25 5.875h3.375A1.125 1.125 0 0 0 13.75 4.75V1.375A1.125 1.125 0 0 0 12.625.25Zm0 4.5H9.25V1.375h3.375V4.75ZM4.75 8.125H1.375A1.125 1.125 0 0 0 .25 9.25v3.375a1.125 1.125 0 0 0 1.125 1.125H4.75a1.125 1.125 0 0 0 1.125-1.125V9.25A1.125 1.125 0 0 0 4.75 8.125Zm0 4.5H1.375V9.25H4.75v3.375ZM12.625 8.125H9.25A1.125 1.125 0 0 0 8.125 9.25v3.375A1.125 1.125 0 0 0 9.25 13.75h3.375a1.125 1.125 0 0 0 1.125-1.125V9.25a1.125 1.125 0 0 0-1.125-1.125Zm0 4.5H9.25V9.25h3.375v3.375Z" />
    </svg>
  )
}

export default DesignIcon
